import React from 'react';
import HasImage from './HasImage';
import NoImage from './NoImage';

function Quote({ image, ...others }) {
  return image ? (
    <HasImage
      image={image}
      {...others}
    />
  ) : <NoImage {...others} />;
}

export default Quote;
